import { render, staticRenderFns } from "./ZohoConfigCard.vue?vue&type=template&id=14945e2b&"
import script from "./ZohoConfigCard.vue?vue&type=script&lang=ts&"
export * from "./ZohoConfigCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports